import React, { useCallback } from "react";
import styles from "./index.module.less";

interface IProps {
  children: any;
  style?: any;
  className?: any;
  onClick?: () => void;
}

function BaseCard({ children, style, className = "", onClick }: IProps) {
  const onOpenCard = useCallback(() => {
    onClick?.();
  }, [onClick]);

  return (
    <div className={`${styles["card"]} ${className}`} style={style} onClick={onOpenCard}>
      {children}
    </div>
  );
}

export default BaseCard;
